import React from 'react';
import SarasUpload from '../../input/upload/SarasUpload'
import * as fn from "../../../helper/uiFunctions";

const FormUpload = (props) => {
    const { formObject, rowKey, headerKey, action } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const onFileSelect = (files) => {
        // console.log("drag drop 2", files);
        let customAction = { ...action };

        if(!customAction.fileList) customAction["fileList"] = {};

        for (var i = 0; i < files.length; i++) {
            customAction.fileList[i] = files[i];
        }

        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    if (fn.compareNumber(hide, 0)) {
        return (
            <SarasUpload onFileSelect={onFileSelect} enableDragNDrop={true}  />
        )
    }
    else
        return (null)
}

export default FormUpload